import { Link } from "react-router-dom";
import { MessageSquare, Phone } from "lucide-react";
import { telHref } from "@/lib/api";
import { scrollToId } from "@/components/site/Header";
import { PoweredBy } from "@/components/site/PoweredBy";

const LEGAL_ENTITY = "The Queue LLC";

export const StickyBar = ({ phone, onMessage }) => (
  <div
    className="fixed inset-x-0 bottom-0 z-50 flex gap-3 border-t border-zinc-800 bg-[#121214]/95 p-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] backdrop-blur-lg md:hidden"
    data-testid="mobile-sticky-bar"
  >
    {phone && (
      <a href={telHref(phone)} className="font-display flex h-12 flex-1 items-center justify-center gap-2 rounded-md bg-[#FFD23F] text-xl text-[#121214]" data-testid="sticky-call-button">
        <Phone className="h-5 w-5" strokeWidth={2.5} /> Call
      </a>
    )}
    <button
      onClick={onMessage || (() => scrollToId("message"))}
      className="font-display flex h-12 flex-1 items-center justify-center gap-2 rounded-md border border-zinc-700 bg-zinc-800 text-xl text-[#FAF7F2]"
      data-testid="sticky-message-button"
    >
      <MessageSquare className="h-5 w-5" /> Message
    </button>
  </div>
);

export const Footer = ({ settings }) => {
  const name = settings?.name || "Jimmyz Restoz";
  const pb = settings?.powered_by;
  return (
    <footer className="border-t-2 border-[#C8102E]/70 bg-[#0d0d0f] pb-28 md:pb-0" data-testid="site-footer">
      <div className="mx-auto grid max-w-7xl gap-8 px-5 py-12 sm:px-8 md:grid-cols-[1fr_auto] md:items-end">
        <div className="space-y-2">
          <p className="font-display text-2xl tracking-wide text-[#FAF7F2]" data-testid="footer-shop-name">{name}</p>
          {settings?.location && <p className="text-sm text-zinc-400" data-testid="footer-location">{settings.location}</p>}
          <Link to="/admin/login" className="inline-block text-sm text-zinc-500 underline-offset-4 transition-colors hover:text-[#FFD23F] hover:underline" data-testid="footer-owner-login-link">
            Owner login
          </Link>
        </div>
        <PoweredBy logo={pb} name={settings?.powered_by_name || "The Queue"} />
      </div>
      <div className="border-t border-zinc-800/80">
        <div className="mx-auto max-w-7xl space-y-1 px-5 py-5 text-xs text-zinc-500 sm:px-8">
          <p data-testid="footer-copyright">© {new Date().getFullYear()} {LEGAL_ENTITY}. All rights reserved.</p>
          <p data-testid="footer-trademark">The Queue™ and the Q logo are trademarks of {LEGAL_ENTITY}.</p>
        </div>
      </div>
    </footer>
  );
};
